import { apiInstances } from '../../../../libs';

const { get } = apiInstances.routesInstance;

export default async function getRoutePickupsPoints({ id_route }) {
  return get(`/routes/${id_route}/wareclouds`);
}
